import { getFirestore, collection, getDocs, getDoc, addDoc, doc, deleteDoc, updateDoc, arrayUnion } from "firebase/firestore";
import app from "./config"; // Ensure this imports your Firebase app configuration

const db = getFirestore(app);

// Fetch all lifts
export const getLifts = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "lifts"));
    return querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error("Error fetching lifts:", error);
    throw error;
  }
};

// Add a new lift
export const addLift = async (lift) => {
  try {
    const docRef = await addDoc(collection(db, "lifts"), lift);
    return docRef.id;
  } catch (error) {
    console.error("Error adding lift:", error);
    throw error;
  }
};

// Update an existing lift
export const updateLift = async (id, updatedFields) => {
  try {
    const liftRef = doc(db, "lifts", id);
    await updateDoc(liftRef, updatedFields);
  } catch (error) {
    console.error("Error updating lift:", error);
    throw error;
  }
};

export const addMovementToLift = async (liftId, movement) => {
  try {
    const liftRef = doc(db, "lifts", liftId); // Reference to the specific lift
    await updateDoc(liftRef, {
      movements: arrayUnion(movement), // Add the new movement to the "movements" array
    });
  } catch (error) {
    console.error("Error adding movement to lift:", error);
    throw error;
  }
};

export const getLiftById = async (id) => {
  try {
    const liftRef = doc(db, "lifts", id);
    const liftSnap = await getDoc(liftRef);

    if (liftSnap.exists()) {
      return { id: liftSnap.id, ...liftSnap.data() };
    } else {
      console.error("Lift not found");
      return null;
    }
  } catch (error) {
    console.error("Error fetching lift by ID:", error);
    throw error;
  }
};

export const deleteLift = async (id) => {
  try {
    const liftRef = doc(db, "lifts", id);
    await deleteDoc(liftRef);
    console.log(`Lift with ID: ${id} deleted successfully`);
  } catch (error) {
    console.error("Error deleting lift:", error);
    throw error;
  }
};

export const deleteMovement = async (liftId, updatedMovements) => {
  try {
    const liftRef = doc(db, "lifts", liftId);
    await updateDoc(liftRef, { movements: updatedMovements });
    console.log("Movement deleted successfully");
  } catch (error) {
    console.error("Error deleting movement:", error);
    throw error;
  }
};